/* AMP3 "Seen it cheaper?" card (snippets/amp3-price-beat-nudge.liquid), Joshua 10 Oct 2026.
   Offers Price Beat when a shopper comes back to the product tab after time away (most likely
   comparing prices) or, on a computer, moves the mouse up out of the page to leave. Both only
   after 10 seconds on the page. Once per visit; a week's rest after it's closed; never while
   another pop-up, drawer, menu, chat, the chat greeting or the cookie banner is showing.
   Test (theme setting): for visitors who allow analytics, half never see it. Their half is saved
   on the basket as attribute _a3_pbn (show, show-seen or hold) when they add something, so
   orders from the two halves can be compared. Price Beat requests sent from the card are
   tagged source "nudge" (amp3-price-beat.js). ?pbn-preview shows it straight away. */
(function () {
  'use strict';
  var card = document.getElementById('a3-pbn');
  if (!card) return;
  var form = document.querySelector('dialog[data-a3-pb]');
  // The address the page was opened with: the theme swaps the query for ?variant=… as it loads.
  var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  var preview = /[?&]pbn-preview(=|&|#|$)/.test(location.search + ' ' + ((nav && nav.name) || ''));
  if (!form || (card.dataset.enabled !== 'true' && !preview)) { card.remove(); return; }

  var REST_KEY = 'amp3:pbn:rest';   // time it may show again after being closed
  var DONE_KEY = 'amp3:pbn:done';   // this visit: shown, used, or not needed
  var GROUP_KEY = 'amp3:pbn:group'; // test half: show | hold
  var SEEN_KEY = 'amp3:pbn:seen';
  var REST_MS = 7 * 864e5;
  var AWAY_MS = (parseFloat(card.dataset.away) || 20) * 1000;
  var ENGAGED_MS = 10000;
  var HIDE_AFTER_MS = 30000;
  var BLOCKERS = 'side-drawer[open], compare-drawer[open], cart-drawer[open], modal-dialog[open], dialog[open], ' +
    'body.overflow-hidden, body.overlay-predictive-search, body.chatway-is-open, .main-nav__item--dropdown.is-open, ' +
    '.gallery-zoom-open, .a3-chatg.is-visible, .a3-cookies.is-visible';

  // false = storage blocked (then never nag), null = not set
  function read(store, key) { try { return window[store].getItem(key); } catch (err) { return false; } }
  function write(store, key, value) { try { window[store].setItem(key, value); } catch (err) { /* storage blocked */ } }

  function testing() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try { return card.dataset.test === 'true' && !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()); } catch (err) { return false; }
  }
  function group() {
    if (!testing()) return null;
    var g = read('localStorage', GROUP_KEY);
    if (g !== 'show' && g !== 'hold') { g = Math.random() < 0.5 ? 'show' : 'hold'; write('localStorage', GROUP_KEY, g); }
    return g;
  }
  function finishVisit() { write('sessionStorage', DONE_KEY, '1'); }
  function resting() {
    if (preview) return false;
    var visit = read('sessionStorage', DONE_KEY), rest = read('localStorage', REST_KEY);
    if (visit === false || rest === false) return true;
    return visit === '1' || Date.now() < (parseInt(rest, 10) || 0);
  }

  // Time the page has actually been on screen.
  var onScreen = 0, since = document.visibilityState === 'visible' ? Date.now() : 0, hiddenAt = 0;
  function engaged() { return onScreen + (since ? Date.now() - since : 0) >= ENGAGED_MS; }

  var state = 'idle'; // idle → waiting (for a clear screen) → shown → gone
  var hideTimer = null;

  function visible(el) { return !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; }
  function blocked() {
    return !!document.querySelector(BLOCKERS) ||
      visible(document.getElementById('shopify-pc__banner')) || visible(document.getElementById('shopify-pc__prefs'));
  }

  function trigger() {
    if (state !== 'idle' || resting()) return;
    if (!preview && group() === 'hold') { state = 'gone'; return; }
    state = 'waiting';
    (function attempt(tries) {
      if (state !== 'waiting') return;
      if (blocked()) {
        if (tries < 15) setTimeout(function () { attempt(tries + 1); }, 1000); else state = 'idle';
        return;
      }
      show();
    })(0);
  }

  function show() {
    state = 'shown';
    finishVisit();
    if (!preview) write('localStorage', SEEN_KEY, '1');
    card.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add('is-visible'); }); });
    hideTimer = setTimeout(function () { hide(false); }, HIDE_AFTER_MS);
  }

  function hide(rest) {
    if (state === 'gone') return;
    if (state !== 'shown') { state = 'gone'; card.remove(); return; }
    state = 'gone';
    clearTimeout(hideTimer);
    if (rest && !preview) write('localStorage', REST_KEY, String(Date.now() + REST_MS));
    if (card.contains(document.activeElement)) document.activeElement.blur();
    card.classList.remove('is-visible');
    setTimeout(function () { card.remove(); }, 300);
  }

  // Leave it up while it's being read.
  function hold() { clearTimeout(hideTimer); hideTimer = null; }
  card.addEventListener('pointerenter', hold);
  card.addEventListener('focusin', hold);

  card.querySelector('[data-a3-pbn-close]').addEventListener('click', function () { hide(true); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state === 'shown' && !form.open) hide(true); });
  card.querySelector('[data-a3-pbn-go]').addEventListener('click', function () {
    hide(false);
    form.dataset.a3PbSource = 'nudge';
    if (!form.open) form.showModal();
  });
  card.querySelector('.a3-pbn__ask').addEventListener('click', function () { hide(false); });

  // Not needed this visit once they've opened Price Beat themselves, opened chat or added to the basket.
  new MutationObserver(function () { if (form.open) { finishVisit(); hide(false); } })
    .observe(form, { attributes: true, attributeFilter: ['open'] });
  document.addEventListener('chatwayWidgetOpened', function () { finishVisit(); hide(false); });
  document.addEventListener('a3:chat-open', function () { finishVisit(); hide(false); });
  document.addEventListener('on:cart:add', function () {
    finishVisit();
    hide(false);
    var g = group();
    if (!g) return;
    var value = g === 'show' && read('localStorage', SEEN_KEY) === '1' ? 'show-seen' : g;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ attributes: { _a3_pbn: value } })
    }).catch(function () { /* the test just loses this one */ });
  });

  // Trigger 1 (all devices): back on the tab after time away.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (since) { onScreen += Date.now() - since; since = 0; }
      hiddenAt = Date.now();
      return;
    }
    since = Date.now();
    var away = hiddenAt ? Date.now() - hiddenAt : 0;
    hiddenAt = 0;
    if (away >= AWAY_MS && onScreen >= ENGAGED_MS) setTimeout(trigger, 700);
  });

  // Trigger 2 (mouse and trackpad only): the pointer leaves through the top of the window.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && engaged()) trigger();
    });
  }

  if (preview) setTimeout(trigger, 800);
})();
